import { render, staticRenderFns } from "./withdrawalSuccess.vue?vue&type=template&id=68bc642f&scoped=true"
import script from "./withdrawalSuccess.vue?vue&type=script&lang=js"
export * from "./withdrawalSuccess.vue?vue&type=script&lang=js"
import style0 from "./withdrawalSuccess.vue?vue&type=style&index=0&id=68bc642f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc642f",
  null
  
)

export default component.exports